import React from "react";
import GeneralTable from "../../components/Table/GeneralTable";
import { useTranslation } from "react-i18next";

export default function Area() {
    const { t } = useTranslation("translation");

    return (
        <div>
            <GeneralTable table="Area" resourcePath="GetDetailedList" id="a_gt" title={t("Area")} search={t("SearchAreaGroup")} />
        </div>
    );
}
